var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"src":_vm.computedSrc,"alt":_vm.alt,"blank":_vm.computedBlank,"blank-color":_vm.blankColor,"width":_vm.computedWidth,"height":_vm.computedHeight,"fluid":_vm.fluid,"fluid-grow":_vm.fluidGrow,"block":_vm.block,"thumbnail":_vm.thumbnail,"rounded":_vm.rounded,"left":_vm.left,"right":_vm.right,"center":_vm.center}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da7de32","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/bootstrap-vue/es/components/image/img-lazy.vue
// module id = 1056
// module chunks = 75